import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAnalyze from '@appStore/analyze/reducers/analyze.reducer';
import * as fromRoot from '../../../reducers';
import { AnalyzeSettingsType, MeteringType } from '@enums';

// feature state
export interface AnalyzeState {
  analyze: fromAnalyze.State;
}

export interface State extends fromRoot.State {
  account: AnalyzeState;
}

// reducers
export const reducers: ActionReducerMap<AnalyzeState> = {
  analyze: fromAnalyze.reducer
};

// Analyze
export const getState = createFeatureSelector<AnalyzeState>('analyze');
export const getAnalyzeState = createSelector(
  getState,
  (state: AnalyzeState) => state.analyze
);
export const getSelectedAnalyzeTabIndex = createSelector(
  getAnalyzeState,
  state => {
    switch (state.selectedAnalyzeSettingsType) {
      case AnalyzeSettingsType.Energy:
        return 0;
      case AnalyzeSettingsType.Flow:
        return 1;
      case AnalyzeSettingsType.Temp:
        return 2;
      case AnalyzeSettingsType.Effect:
        return 3;
      case AnalyzeSettingsType.Economy:
        return 4;
    }
  }
);

export const getSelectedMeteringTabIndex = createSelector(
  getAnalyzeState,
  state => {
    switch (state.selectedAnalyzeSettingsMeteringType) {
      case MeteringType.Hot:
        return 0;
      case MeteringType.Cold:
        return 1;
      case MeteringType.HotLogical:
        return 2;
      case MeteringType.ColdLogical:
        return 3;
    }
  }
);

export const getAnalyzeSettings = createSelector(
  getAnalyzeState,
  fromAnalyze.getAnalyzeSettings
);
export const getAnalyzePeriodData = createSelector(
  getAnalyzeState,
  fromAnalyze.getAnalyzePeriodData
);

export const getSelectedAnalyzeSettingsType = createSelector(
  getAnalyzeState,
  fromAnalyze.getSelectedAnalyzeSettingsType
);
export const getTemperatureMeteringPoints = createSelector(
  getAnalyzeState,
  fromAnalyze.getTemperatureMeteringPoints
);

export const getReportKey = createSelector(
  getAnalyzeState,
  fromAnalyze.getReportKey
);
export const getResetPeriod = createSelector(
  getAnalyzeState,
  fromAnalyze.getResetPeriod
);

export const getResetGraph = createSelector(
  getAnalyzeState,
  fromAnalyze.getResetGraph
);

export const getDataLoadFailed = createSelector(
  getAnalyzeState,
  fromAnalyze.getDataLoadFailed
);
